import { DayOfWeek } from "office-ui-fabric-react";
import { DateTime } from "luxon";
import { ApplicationState } from "..";

/**
 * Gets the first day of week setting from tenant settings.
 * Uses tenant setting > default (Sunday)
 */
export const getFirstDayOfWeekSetting = (state: ApplicationState): DayOfWeek => {
    const tenantFirstDayOfWeek = state.tenant.globalSettings?.firstDayOfWeek;

    return tenantFirstDayOfWeek ?? DayOfWeek.Sunday;
};

/**
 * Gets today's date in the tenant timezone, as local midnight so it compares directly with dates parsed by toDate.
 * Falls back to browser local time when the tenant timezone is missing or obsolete.
 */
export const getTenantToday = (state: ApplicationState): Date => {
    const timezone = state.tenant.globalSettings?.timezone;
    const tenantNow = timezone ? DateTime.now().setZone(timezone) : DateTime.now();
    const today = tenantNow.isValid ? tenantNow : DateTime.now();

    return new Date(today.year, today.month - 1, today.day);
};
